<div
  class="justify-between py-1 px-5 shadow-xl shadow-black/10 bg-(--color-header-bg) h-15 hidden lg:flex"
>
  <div class="flex justify-center items-center">
    <div class="flex gap-3">
      <!-- <mat-icon class="h-14! w-40!" svgIcon="logo_holanda"></mat-icon>
      <mat-icon
        class="h-14! w-40! text-amber-300! fill-teal-400!"
        svgIcon="logo_ei_azul"
      ></mat-icon> -->
      <img src="assets/icons/logo_holanda.svg" class="h-14! w-40!" />
      <img src="assets/icons/logo_ei_azul.svg" class="h-14! w-40!" />
    </div>
  </div>

  <div class="flex justify-center items-center gap-4">
    <mat-icon [matMenuTriggerFor]="userProfile" class="w-10! h-10! text-[40px]! cursor-pointer"
      >account_circle</mat-icon
    >
  </div>
</div>

<!-- <div class="w-(--width-full) bg-[#f9f2f4] flex items-center justify-center"> -->
<div class="lg:hidden!">
  <div class="h-2 w-full bg-white"></div>
  <div class="p-0 w-(--width-full) flex items-center justify-between bg-[#f9f2f4]">
    <div class="h-15 bg-white">
      <div class="h-5 bg-white"></div>
      <div class="border-h-right h-5 border-r-0! border-b-0!">
        <div
          class="size-11 border-(--comp-icon-color-primary)! bg-white border-2 rounded-full flex items-center justify-center relative -top-4 left-2"
        >
          <mat-icon
            class="w-10! h-10!"
            (click)="addParamToUrl(['home'], { statusSelected: 2 })"
            svgIcon="icon_perfil"
          ></mat-icon>
        </div>
      </div>
      <div class="h-5 bg-[#f9f2f4] w-full"></div>
    </div>
    <div class="bg-white w-full rounded-b-[40px]">
      <div class="flex flex-col items-center h-15 w-full border-h">
        <div class="h-15 flex flex-col items-center">
          <div class="flex items-center gap-2 h-13">
            <div class="text-general-subtitle">
              <span class="font-bold text-(--color-text-primary)!">Hola</span>
              <span class="text-(--color-text-primary)! font-medium"> {{ name }}</span>
            </div>
            <mat-icon
              class="w-10! h-10!"
              (click)="addParamToUrl(['home'], { statusSelected: 0 })"
              svgIcon="icon_corazon"
            ></mat-icon>
          </div>
          <div class="border-b-2 border-gray-300 w-15"></div>
        </div>
      </div>
    </div>
    <div class="h-15 bg-white">
      <div class="h-5 bg-white"></div>
      <div class="border-h-left h-5 border-r-0! border-b-0!">
        <div
          class="size-11 border-(--comp-icon-color-primary)! bg-white border-2 rounded-full flex items-center justify-center relative -top-4 left-2"
        >
          <mat-icon
            class="w-10! h-10!"
            (click)="addParamToUrl(['home'], { statusSelected: 1 })"
            svgIcon="icon_carrito"
            [matBadge]="cont"
          ></mat-icon>
        </div>
      </div>
      <div class="h-5 bg-[#f9f2f4] w-full"></div>
    </div>
  </div>
</div>
<!-- </div> -->

<mat-menu #userProfile="matMenu">
  <div class="flex justify-center items-center gap-4" (click)="logout()" mat-menu-item>
    <mat-icon class="w-7! h-7! text-[28px]! cursor-pointer">close</mat-icon>
    {{ 'fieldNames.logout' | translate }}
  </div>
</mat-menu>
